import { colors } from '../../colors';
var address = {
  addressColor: colors.equineIron
};
export default address;